import { createGlobalStyle } from "styled-components"
import variables from "@/components/Calendar/styles/variables"
import toolbar from "@/components/Calendar/styles/toolbar"
import reset from "@/components/Calendar/styles/reset"
import agenda from "@/components/Calendar/styles/agenda"
import month from "@/components/Calendar/styles/month"
import event from "@/components/Calendar/styles/event"
import timeGrid from "@/components/Calendar/styles/time-grid"
import { getCssSizeValue, getFontSize } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

//TODO: Not all styles are properly applied
export default createGlobalStyle`
	${reset}
	${toolbar}
	${event}
	${month}
	${agenda}
	${timeGrid}
		//font-family: var(--font-borna);
	.rbc-calendar {
		box-sizing: border-box;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: stretch;
		//min-height: 100svh;
		font-family: var(--font-strawford);
		${variables};

		button {
			font-family: var(--font-borna);
		}
	}

	.rbc-calendar *,
	.rbc-calendar *:before,
	.rbc-calendar *:after {
		box-sizing: inherit;
	}

	.rbc-abs-full {
		overflow: hidden;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.rbc-ellipsis {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.rbc-rtl {
		direction: rtl;
	}

	.rbc-off-range {
		color: var(--out-of-range-color);

		&.rbc-date-cell {
			.rbc-button-link {
				font-weight: 400;
			}
		}
	}

	.rbc-off-range-bg {
		background: var(--out-of-range-bg-color);
	}

	.rbc-header {
		overflow: hidden;
		flex: 1 0 0%;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding: 0 3px;
		text-align: center;
		vertical-align: middle;
		font-weight: bold;
		font-size: 90%;
		min-height: 0;
		border-bottom: 1px solid var(--cell-border);
		border-left: 1px solid var(--cell-border);
		text-transform: uppercase;


		.rbc-rtl {
			border-left-width: 0;
			border-right: 1px solid var(--cell-border);
		}

		& > a {
			&,
			&:active,
			&:visited {
				color: inherit;
				text-decoration: none;
			}
		}
	}

	.rbc-button-link {
		color: ${({ theme }) => theme.colors.black};
		font-weight: ${({ theme }) => theme.fontWeight.semiBold};
		background: none;
		margin: 0;
		border: none;
		pointer-events: none;
		//cursor: pointer;
		user-select: text;
		height: 100%;
		padding: ${getCssSizeValue(4, BREAKPOINTS.MOBILE)};
		font-size: ${getFontSize(14, BREAKPOINTS.MOBILE)};
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			font-size: ${getFontSize(14)};
			padding: ${getCssSizeValue(8)};
		}

	}

	.rbc-row-content {
		position: relative;
		user-select: none;
		-webkit-user-select: none;
		z-index: 4;
			//row-gap: ${getCssSizeValue(8)};
	}

	.rbc-row-content-scrollable {
		display: flex;
		flex-direction: column;
		height: 100%;

		.rbc-row-content-scroll-container {
			height: 100%;
			overflow-y: scroll;

			/* Hide scrollbar for Chrome, Safari and Opera */

			&::-webkit-scrollbar {
				display: none;
			}

			-ms-overflow-style: none; /* IE and Edge */
			scrollbar-width: none; /* Firefox */
		}
	}

	.rbc-today {
		background-color: var(--today-highlight-bg);
	}
`
